module.exports = __webpack_public_path__ + "static/media/veneto-3-11.4f741425.jpg";